import useTheme from '../../hooks/ui/useTheme';

interface Props {
  className?: string;
  style?: object;
  color?: string;
}

export default function SideBarIcon(props: Props) {
  const { className, color, style } = props;
  const theme = useTheme();
  return (
    <svg
      className={className ?? 'h-[14px] w-[14px]'}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path d="M1 1H13" stroke={color ?? theme.color.gray['100']} strokeWidth="2" strokeLinecap="round" />
      <path d="M1 7H13" stroke={color ?? theme.color.gray['100']} strokeWidth="2" strokeLinecap="round" />
      <path d="M1 13H13" stroke={color ?? theme.color.gray['100']} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
